import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-light mt-5">
      {/* Fixed Shape Background */}
      <div className="fixed-shape">
        <img
          src="https://wpriverthemes.com/tandaelem/wp-content/themes/tanda/img/map.svg"
          alt="Shape"
        />
      </div>

       {/* Main Footer Content */}
       <div className="container">
        <div className="f-items default-padding py-5">
          <div className="row">
            {/* About Section */}
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4 ">
              <div className="f-item about">
              <img
                  src="https://knackhire.azurewebsites.net/static/media/knackhire-new.fe8d9b9e9acf584d2427.png"
                  alt="Logo"
                  style={{ height: "50px",backgroundColor:'#fff' }}
                />
               <p className="mt-3" style={{color:'#fff'}}>
                  Manual resume screening is time-consuming & inefficient. Evaluating
                  candidates through traditional methods lacks speed & accuracy.
                  Managing job submissions, candidates, and vendors is often disorganized.
                </p>
              </div>
            </div>

              {/* KnackHire Links */}
              <div className="col-lg-2 col-md-6 mb-4">
              <div className="f-item link">
                <h4 className="widget-title text-white">KnackHire</h4>
                <ul className="list-unstyled">
                <li><a href="/#Home">Home</a></li>
                  <li><a href="/#About">About</a></li>
                  <li><a href="/#Keybenefits">Key Benefits</a></li>
                  <li><a href="/#WhyKnackHire">Why KnackHire</a></li>
                </ul>
              </div>
            </div>
 
            {/* Solutions Links */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="f-item link">
                <h4 className="widget-title text-white">Solutions</h4>
                <ul className="list-unstyled">
                  <li><a href="/#About">Our Services</a></li>
                  <li><a href="/#WorkProcess">Core Features</a></li>
                  <li><a href="/#PricingPlans">Pricing Plans</a></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
  <div className="f-item link">
  <h4 className="widget-title text-white">Contact Info</h4>

    <ul className="list-unstyled">
    <li className="d-flex flex-column flex-sm-row align-items-center gap-2 mt-3">
        <i className="fa fa-map-marker"></i>
        <p className="text-white mb-0"> 
        KNACKHOOK LLC
          1420 156TH AVE NE SUITE F,<br />
          BELLEVUE, WA 98007-4421.
        </p>
      </li>
   
      <li className="d-flex flex-column flex-sm-row align-items-center text-center gap-2 mt-3">
        <i className="fa fa-envelope"></i>
        <p className="text-white mb-0"> hire@knackhook.com</p>
      </li>
      <li className="d-flex flex-column flex-sm-row align-items-center text-center gap-2 mt-3">
        <i className="fa fa-phone"></i>
        <p className="text-white mb-0">+1 (425) 548-6321</p>
      </li>
    </ul>
  </div>
</div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom py-3" style={{backgroundColor:'#00a7ac !important'}}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 ">
              <p className="mb-0 text-white">© Copyright 2025. KnackHire</p>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
.bg-dark {
    background: #00a7ac !important;
}
 footer .fixed-shape {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          text-align: center;
          display: none;
        }

        footer .f-items.default-padding {
          padding-top: 70px;
        }

        footer .item {
          margin-top: 50px;
        }

        footer.bg-dark .f-item.about {
          padding: 50px 37px;
        background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.3);
          margin-right: 15px;
          color: #fff;
        }

        footer.bg-dark .f-item.about p {
          color: #000;
        }

        ul {
          margin: 0;
          list-style-type: none;
          color: #fff;
        }

        footer .f-item.link li {
          margin-bottom: 10px;
        }

        a {
          color: #fff;
          text-decoration: none;
        }

        footer .address li {
          display: flex;
        }

        footer .address li i {
          font-size: 20px;
          margin-right: 15px;
          position: relative;
          top: 5px;
        }

        footer .footer-bottom {
          background-color: #00a7ac;
        }

        /* Media Queries */
        @media (max-width: 992px) {
          footer .f-item {
            padding: 30px 20px;
          }
          .footer-bottom {
            text-align: center;
          }
        }

        @media (max-width: 768px) {
          footer .f-items.default-padding {
            padding-top: 40px;
          }
          footer .col-lg-4, .col-lg-2 {
            margin-bottom: 30px;
          }
        }

        @media (max-width: 576px) {
          footer .f-items.default-padding {
            padding-top: 20px;
          }
          footer .col-lg-4, .col-lg-2 {
            text-align: center;
            margin-bottom: 20px;
          }

          footer .f-item.about {
            padding: 20px 15px;
          }
        }
`}</style>
    </footer>
    
  );
};

export default Footer;
